import type { ReactNode } from 'react';

import { User } from '@ergeon/erg-auth';

import useStorageUserID from '../../hooks/useStorageUserID';
import useSentryUser from '../../hooks/useSentryUser';

import AuthContext from './AuthContext';

const AuthWrapperContent = ({ user, children }: {user: User; children: ReactNode}) => {
  useStorageUserID(user);
  useSentryUser(user);

  return <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>;
};

export default AuthWrapperContent;
